module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBbaIe17AAAAS0lEQVQ4y2P4jwQ+MAww7wADDNgPCh7QVX8GB4/5PwMD////g4HHD4kshsHAA4XSAf4/g4PHDEnHg4EHdBQkOQ8C3oDnYgRv8JR1ABoO2Be9HfQiAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA4LTEzVDE1OjI3OjA4KzA5OjAwEILqywAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxMy0xMC0wOFQwNjowODoyMiswOTowMD+oKM0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h10/tag36_10_00765_100x100.png
// module id = VfME
// module chunks = 0